export const brandConfig = {
  name: 'BIT CODE',
  legalName: 'BIT CODE',
  inn: '594811105161',
  domain: 'bit-code.pro',
  siteUrl: 'https://bit-code.pro',
  email: 'ooostalkor@yandex.ru',
  telegramBot: 'bitcodecryptobot',
  telegramOperator: 'bittcode',
  telegramChannel: 'bitcodeperm',
  whatsapp: '79223735231',
  phone: '+7 922 373 5231',
  phones: [
    { label: 'Россия', value: '+7 922 373 5231', href: '+79223735231' },
  ],
  office: {
    address: 'г. Пермь, ул. Куйбышева, 37',
    mapUrl: 'https://www.google.com/maps/place/ул.+Куйбышева,+37,+Пермь,+Пермский+край,+Россия,+614045/@58.0074895,56.2338835,18z/data=!3m1!4b1!4m6!3m5!1s0x43e8c725ff142f4d:0xbbddc3b7394888d9!8m2!3d58.0074881!4d56.235171!16s%2Fg%2F11cskswmql?entry=ttu&g_ep=EgoyMDI2MDYyOC4wIKXMDSoASAFQAw%3D%3D',
    mapEmbedUrl:
      'https://www.google.com/maps?q=%D0%B3.%20%D0%9F%D0%B5%D1%80%D0%BC%D1%8C%2C%20%D1%83%D0%BB.%20%D0%9A%D1%83%D0%B9%D0%B1%D1%8B%D1%88%D0%B5%D0%B2%D0%B0%2C%2037&z=18&output=embed',
  },
} as const;

const telegramText = encodeURIComponent(
  'Здравствуйте! Пишу с сайта. Подскажите, пожалуйста, условия обмена',
);

export const brandLinks = {
  email: `mailto:${brandConfig.email}`,
  telegramBot: `tg://resolve?domain=${brandConfig.telegramBot}`,
  telegramOperator: `tg://resolve?domain=${brandConfig.telegramOperator}`,
  telegramOperatorWithText: `tg://resolve?domain=${brandConfig.telegramOperator}&text=${telegramText}`,
  telegramChannel: `tg://resolve?domain=${brandConfig.telegramChannel}`,
  whatsapp: brandConfig.whatsapp ? `https://wa.me/${brandConfig.whatsapp}` : '',
} as const;
